<template>
  <div class="options">
    <h1>Reports</h1>
  </div>
</template>

<script>
export default {
  name: "Reports",
  components: {},
  data() {
    return {
      showTrucks: false
    };
  }
};
</script>
